// IE 2026 09 08 / ODOO-… (заказ Игоря, Alt+Tab): переключение виджетов страницы «как окон в ОС».
//
// Как устроено:
// - Alt+Tab (Alt зажат, Tab) — по центру экрана лист видимых виджетов текущей страницы, в стиле
//   мобильного меню виджетов (Page.vue .mobile-widgets-list). Повторный Tab при зажатом Alt двигает
//   выделение НАЗАД по списку, Shift+Tab — вперёд (замечание Игоря 08.09: направления обратные
//   ОС-овским); отпускание Alt делает выделенный виджет активным
//   (widget_activate + клавиатура в его грид); Esc / клик мимо листа — отмена, активный не меняется;
//   клик по строке листа — сразу переключиться на неё.
// - живой предпросмотр (замечание Игоря 08.09): выделенный при переборе виджет активируется СРАЗУ
//   (widget_activate — рамка, прокрутка стола к нему) и на время перебора поднимается поверх остальных
//   атрибутом data-alt-tab-lift на #WIDGET<id> (CSS: z-index выше свободных виджетов), даже если он
//   докирован, а над ним свободные. Именно атрибут, не класс: класс контейнера — реактивный binding
//   Widget.vue, и при активации Vue переписывает className целиком, стирая чужие классы.
//   После отпускания Alt атрибут снимается — свободные снова над докированными, как обычно;
//   Esc/отмена возвращает активность виджету, который был активен до Alt+Tab.
//   Выкл. предпросмотра: fe.ux.altTabPreview = false (тогда активация только по отпусканию Alt).
// - порядок листа (замечание Игоря 08.09): как виджеты размещены на экране — по левому верхнему углу,
//   строки сверху вниз, внутри строки слева направо (строка = верхние края в пределах ROW_TOL px);
//   сначала блок докированных виджетов, затем блок свободных (styleWidget.dock === 'popout'), блоки
//   подписаны в листе (Docked / Free); выделение стартует со следующего за активным.
//   Запасной порядок fe.ux.altTabOrder = 'recent' — по давности активации, как в ОС (давность ведётся
//   здесь точечным watch на store.activeWIDGET.id: store.frontHistory пополняется только при ОТКРЫТИИ
//   виджета, а не при активации кликом).
// - ход выделения (замечание Игоря 09.09): список — в экранном порядке, а Tab ходит ПО ИСТОРИИ активаций
//   (как Alt+Tab в ОС): первый Tab выделяет виджет, который был активен перед текущим, следующий Tab —
//   активный перед ним и т.д.; Shift+Tab — в обратную сторону (первый Shift+Tab — самый давний). Так
//   одиночный Alt+Tab возвращает на предыдущий виджет, а повторный — обратно на исходный. Предпросмотр при
//   переборе историю НЕ двигает (_touch глушится, пока лист открыт): в неё попадает только виджет, на котором
//   отпустили Alt, — иначе после перебора в три шага повторный Alt+Tab вёл бы не на исходный. Порядок хода
//   показан цифрами у иконок (когда строк больше двух). Внутренняя опция fe.ux.altTabHistory (по умолчанию
//   включено): window.feSettings.set('fe.ux.altTabHistory', false) — прежний ход по строкам списка
//   (Tab — строка выше, Shift+Tab — ниже).
// - IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): под блоками открытых виджетов — блок Closed:
//   виджеты ЭТОЙ страницы из стека мягко закрытых store.closedWidgets (тот же стек снимает Alt+Esc — restoreLastClosedWidget,
//   самый свежий первым; запись стека живёт до следующего закрытия и ещё 5 минут после него — _widget_hardClose по таймеру).
//   Перебор Tab / Shift+Tab и предпросмотр по этим строкам НЕ ходят (index ходит только по items), наведение их не выделяет;
//   вернуть закрытый виджет можно только кликом мыши по строке — reopen(j): тот же путь, что у «открыть тот же виджет снова»
//   (_widget_restoreSoftClosed + widget_activate). Лист открывается и когда открытых виджетов нет, а закрытые есть (index −1).
//   Выключатель fe.ux.altTabClosed (по умолчанию включено): window.feSettings.set('fe.ux.altTabClosed', false).
// - «видимый» = виджет активной страницы, не закрыт (close/_softClosed) и его контейнер
//   #WIDGET<id> имеет размер на экране (popout-ы и дочерние формы записи — тоже).
// - keydown приходит из общего обработчика App.vue (capture, до гридов): onKeyDown → true =
//   событие наше (preventDefault + stopPropagation: Tab не уходит в грид и не двигает фокус);
//   keyup Alt / blur окна / скрытие вкладки — свои слушатели (install). Страховка: потерян
//   keyup Alt (фокус ушёл в iframe/devtools) — лист закрывается сам через 20 с.
// - на Windows/Linux сочетание Alt+Tab перехватывает ОС и до браузера оно не доходит —
//   там переключатель недоступен по природе; на macOS (Option+Tab) работает.
// - выключатель: настройка fe.ux.altTab (по умолчанию включено):
//   window.feSettings.set('fe.ux.altTab', false) / .reset(); счётчики — window.altTab.stats.
import { reactive, markRaw, watch } from 'vue'
import { Control } from '@mescius/wijmo'
import altTooltip from './altTooltip'   // IE 2026 10 12 / ODOO-5800: гасить Alt-подсказку при открытии листа

const altTab = {
    state: reactive({
        open: false,     // лист показан (Alt зажат)
        items: [],       // [{id, title, pi, group, W}] — видимые виджеты страницы в порядке листа
        index: 0,        // выделенная строка
        currentId: null, // id активного на момент открытия (отметка «был активен», возврат по Esc)
        captions: false, // подписывать блоки Docked / Free (оба блока непустые, порядок 'screen')
        walk: [],        // IE 2026 09 09 / ODOO-…: индексы строк по давности активации [текущий, предыдущий, …] — путь Tab
        pos: 0,          // IE 2026 09 09 / ODOO-…: позиция выделения на пути walk
        history: true,   // IE 2026 09 09 / ODOO-…: ход по истории (снимок fe.ux.altTabHistory на момент открытия — подсказка, цифры)
        closed: [],      // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): [{id, title, pi, W}] — закрытые виджеты страницы, которые вернёт Alt+Esc (свежие первыми)
    }),
    _origW: null,        // виджет, активный до открытия листа — возврат при отмене
    _liftedEl: null,     // контейнер #WIDGET<id>, поднятый атрибутом data-alt-tab-lift на время перебора
    store: null,
    stats: { opens: 0, switches: 0, cancels: 0, reopens: 0 },   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): reopens — возвраты кликом по строке Closed
    _installed: false,
    _guard: null,
    _recent: [],     // id виджетов по давности активации (свежие — в начале)

    enabled() {
        try { return this.store?.setting?.('fe.ux.altTab', true) !== false } catch (e) { return true }
    },
    order() {
        try { return this.store?.setting?.('fe.ux.altTabOrder', 'screen') === 'recent' ? 'recent' : 'screen' } catch (e) { return 'screen' }
    },
    preview() {
        try { return this.store?.setting?.('fe.ux.altTabPreview', true) !== false } catch (e) { return true }
    },
    // IE 2026 09 09 / ODOO-… (замечание Игоря): Tab ходит по истории активаций; false — по строкам списка, как раньше
    history() {
        try { return this.store?.setting?.('fe.ux.altTabHistory', true) !== false } catch (e) { return true }
    },
    // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): блок Closed в листе; false — не показывать
    closedOn() {
        try { return this.store?.setting?.('fe.ux.altTabClosed', true) !== false } catch (e) { return true }
    },

    install(store) {
        this.store = store
        if (this._installed) return
        this._installed = true
        this._onKeyUp = (e) => this.onKeyUp(e)
        this._onBlur = () => this.cancel()
        this._onVisibility = () => { if (document.visibilityState !== 'visible') this.cancel() }
        document.addEventListener('keyup', this._onKeyUp, true)
        window.addEventListener('blur', this._onBlur)
        document.addEventListener('visibilitychange', this._onVisibility)
        // давность активации: только точечный watch поля (deep-watch стора читает wijmo-геттеры виджетов)
        this._stopWatch = watch(() => store.activeWIDGET?.id, (id) => this._touch(id), { immediate: true })
        window.altTab = this
    },
    uninstall() {
        if (!this._installed) return
        this._installed = false
        document.removeEventListener('keyup', this._onKeyUp, true)
        window.removeEventListener('blur', this._onBlur)
        document.removeEventListener('visibilitychange', this._onVisibility)
        this._stopWatch?.(); this._stopWatch = null
        this.cancel()
    },
    _touch(id) {
        if (id === undefined || id === null) return
        if (this.state.open) return   // IE 2026 09 09 / ODOO-…: предпросмотр при переборе историю не двигает — её пополняет commit
        const i = this._recent.indexOf(id)
        if (i >= 0) this._recent.splice(i, 1)
        this._recent.unshift(id)
        if (this._recent.length > 100) this._recent.length = 100
    },

    // App.vue handleKeydown (capture): true — событие обработано здесь
    onKeyDown(e) {
        const st = this.state
        if (st.open) {
            if (e.key === 'Escape') { this._eat(e); this.cancel(); return true }
            if (e.key === 'Tab' && !e.ctrlKey && !e.metaKey) { this._eat(e); this.step(this._dir(e)); return true }
            if (e.key === 'Alt' || e.altKey) { this._eat(e); return true }   // прочие Alt-сочетания на время выбора глушим
            // клавиша без Alt — Alt уже отпущен, а keyup потерян (фокус уходил из окна): применить выбор
            this._eat(e); this.commit(); return true
        }
        if (e.key !== 'Tab' || !e.altKey || e.ctrlKey || e.metaKey) return false
        if (!this.enabled()) return false
        this._eat(e)
        this.open(this._dir(e))
        return true
    },
    // направление шага (замечание Игоря 08.09): Tab — назад по списку (-1), Shift+Tab — вперёд (+1)
    _dir(e) { return e.shiftKey ? 1 : -1 },
    onKeyUp(e) {
        if (!this.state.open || e.key !== 'Alt') return
        this._eat(e)   // и штатное действие браузера на одиночный Alt (фокус на меню окна)
        this.commit()
    },

    // экранный порядок по левому верхнему углу: строки сверху вниз (верхние края в пределах ROW_TOL px —
    // одна строка), внутри строки слева направо
    ROW_TOL: 16,
    _readingOrder(items) {
        const byTop = items.slice().sort((a, b) => a.top - b.top || a.left - b.left)
        const rows = []
        for (const it of byTop) {
            const row = rows[rows.length - 1]
            if (row && it.top - row.top <= this.ROW_TOL) row.items.push(it)
            else rows.push({ top: it.top, items: [it] })
        }
        const out = []
        for (const row of rows) out.push(...row.items.sort((a, b) => a.left - b.left || a.top - b.top))
        return out
    },
    // видимые виджеты активной страницы: блок докированных, затем блок свободных, каждый в экранном порядке;
    // при 'recent' — активный, затем по давности активации
    collect() {
        const store = this.store
        const WS = store?.activeWORKSPACE
        const page = WS?.activePAGE?.page ?? WS?.active_page
        if (!WS || !page) return []
        const seen = []
        for (const W of (WS.ALL_WIDGETS || [])) {
            if (!W || W.page !== page || W.close || W._softClosed) continue
            const el = document.getElementById('WIDGET' + W.id)
            const r = el?.getBoundingClientRect()
            if (!r || !(r.width > 0 && r.height > 0)) continue
            seen.push({ W, top: r.top, left: r.left, group: W.styleWidget?.dock === 'popout' ? 'free' : 'dock' })
        }
        const docked = this._readingOrder(seen.filter(s => s.group === 'dock'))
        const free = this._readingOrder(seen.filter(s => s.group === 'free'))
        let list = docked.concat(free)
        let captions = docked.length > 0 && free.length > 0
        if (this.order() === 'recent') {
            const rank = new Map(this._recent.map((id, i) => [id, i]))
            const r = (s) => rank.has(s.W.id) ? rank.get(s.W.id) : Number.MAX_SAFE_INTEGER
            list = list.slice().sort((a, b) => r(a) - r(b))   // sort стабильный: не активировавшиеся — в экранном порядке
            const act = store.activeWIDGET
            const i = list.findIndex(s => s.W === act)
            if (i > 0) list.unshift(...list.splice(i, 1))
            captions = false   // блоки перемешаны по давности — подписи не имеют смысла
        }
        this.state.captions = captions
        return list.map(({ W, group }) => markRaw({
            id: W.id,
            title: W.title || W.shortTitle || W.record?.title || W.widget || ('#' + W.id),
            pi: W.pi || 'pi pi-table',
            group,
            W,
        }))
    },
    // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): закрытые виджеты ТЕКУЩЕЙ страницы, которые может вернуть Alt+Esc —
    // записи стека store.closedWidgets (мягко закрытые: _softClosed, остаются в ALL_WIDGETS) с вершины вниз, т.е. в порядке,
    // в котором их снимал бы Alt+Esc; закрытые на других страницах / столах не показываются (лист — про эту страницу).
    // Скрыто открытые (_hiddenOpen) и жёстко закрытые (close) в стеке не лежат — их и Alt+Esc не вернёт.
    collectClosed() {
        if (!this.closedOn()) return []
        const store = this.store
        const WS = store?.activeWORKSPACE
        const page = WS?.activePAGE?.page ?? WS?.active_page
        if (!WS || !page) return []
        const stack = store.closedWidgets || []
        const out = []
        for (let i = stack.length - 1; i >= 0; i--) {
            const W = stack[i]?.WIDGET
            if (!W || W.close || !W._softClosed || W.workspace !== WS.workspace || W.page !== page) continue
            if (out.some(it => it.W === W)) continue
            out.push(markRaw({
                id: W.id,
                title: W.title || W.shortTitle || W.record?.title || W.widget || ('#' + W.id),
                pi: W.pi || 'pi pi-table',
                group: 'closed',
                W,
            }))
        }
        return out
    },
    // IE 2026 09 09 / ODOO-… (замечание Игоря): путь Tab по истории — индексы строк листа по давности активации: текущий,
    // затем предыдущие; не активировавшиеся в этой сессии — в конце, в порядке листа (sort стабильный)
    _walk(items, currentId) {
        const rank = new Map(this._recent.map((id, i) => [id, i]))
        const r = (it) => rank.has(it.id) ? rank.get(it.id) : Number.MAX_SAFE_INTEGER
        const walk = items.map((it, i) => i).sort((a, b) => r(items[a]) - r(items[b]))
        const c = walk.indexOf(items.findIndex(it => it.id === currentId))
        if (c > 0) walk.unshift(...walk.splice(c, 1))
        return walk
    },
    open(dir) {
        const items = this.collect()
        const closed = this.collectClosed()   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab)
        if (!items.length && !closed.length) return
        const st = this.state
        st.items = items
        st.closed = closed   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab)
        // с блоком Closed открытые строки тоже подписаны (Docked / Free) — иначе не видно, где кончаются открытые; при 'recent' блоки
        // перемешаны, подписи по-прежнему нет
        if (closed.length && this.order() !== 'recent') st.captions = true   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab)
        const act = this.store?.activeWIDGET
        this._origW = act || null
        st.currentId = act?.id ?? null
        const cur = items.findIndex(it => it.id === st.currentId)
        const n = items.length
        st.walk = this._walk(items, st.currentId)   // IE 2026 09 09 / ODOO-…
        st.history = this.history()
        if (!n) {   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): открытых нет — только блок Closed, выделения нет (Tab / отпускание Alt ничего не делают)
            st.index = -1; st.pos = 0
        } else if (st.history) {
            st.pos = dir < 0 ? 1 % n : n - 1   // Tab — предыдущий по активности, Shift+Tab — самый давний
            st.index = st.walk[st.pos]
        } else {
            st.index = cur < 0 ? 0 : (cur + dir + n) % n
            st.pos = Math.max(0, st.walk.indexOf(st.index))
        }
        st.open = true
        this.stats.opens++
        // IE 2026 10 12 / ODOO-5800 (замечание Игоря, скрин 12.10): Alt уже зажат — подсказка элемента под мышью (карточка ячейки, кнопки)
        // показана ДО Tab и висела поверх листа; при открытии листа её гасим (внутри листа подсказок по Alt нет — App.vue / altTooltip.probe)
        try { altTooltip._lingerCancel(true); altTooltip._hide() } catch (e) { /* подсказки могло не быть */ }
        try { window.dispatchEvent(new CustomEvent('ie-overlay-open', { detail: { kind: 'alt-tab' } })) } catch (e) { /* без стража */ }   // IE 2026 09 28 / ODOO-… (замечание Игоря: зависает меню угла виджета): переключатель Alt+Tab закрывает ⋯-форму угла виджета (cornerFormGuard)
        this._arm()
        this._preview()
    },
    step(dir) {
        const st = this.state
        const n = st.items.length
        if (!n) return
        if (st.history) {   // IE 2026 09 09 / ODOO-…: Tab (dir -1) — дальше в прошлое по walk, Shift+Tab (+1) — обратно
            st.pos = (st.pos - dir + n) % n
            st.index = st.walk[st.pos]
        } else {
            st.index = (st.index + dir + n) % n
            st.pos = Math.max(0, st.walk.indexOf(st.index))
        }
        this._arm()
        this._preview()
    },
    select(i) {
        const st = this.state
        if (i >= 0 && i < st.items.length && i !== st.index) { st.index = i; st.pos = Math.max(0, st.walk.indexOf(i)); this._preview() }
    },
    // живой предпросмотр: выделенный виджет активируется сразу и поднимается поверх остальных
    _preview() {
        if (!this.preview()) return
        const W = this.state.items[this.state.index]?.W
        const store = this.store
        if (!W || !store || W.close) { this._unlift(); return }
        try {
            if (store.activeWIDGET !== W) store.widget_activate(W, 'altTab:preview', true, false)
        } catch (e) { if (!store.hide_console) console.warn('altTab: preview activate failed', e) }
        this._lift(document.getElementById('WIDGET' + W.id))
    },
    _lift(el) {
        if (this._liftedEl === el) return
        this._unlift()
        if (el) { el.setAttribute('data-alt-tab-lift', '1'); this._liftedEl = el }
    },
    _unlift() {
        if (this._liftedEl) { this._liftedEl.removeAttribute('data-alt-tab-lift'); this._liftedEl = null }
    },
    commit(i) {
        const st = this.state
        if (!st.open) return
        if (i !== undefined) this.select(i)
        const it = st.items[st.index]
        const origW = this._origW
        this.close()
        const W = it?.W
        const store = this.store
        if (!W || !store || W.close) return
        if (W._softClosed) store._widget_restoreSoftClosed?.(W)
        if (store.activeWIDGET !== W) store.widget_activate(W, 'altTab', true, false)
        this._touch(W.id)   // IE 2026 09 09 / ODOO-…: в историю — только виджет, на котором отпустили Alt (предпросмотр её не двигал)
        if (W !== origW) this.stats.switches++
        setTimeout(() => this._focus(W), 60)
    },
    // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab): клик по строке блока Closed — вернуть именно этот виджет.
    // Тот же путь, что у «открыть тот же виджет снова» (widget_open существующего _softClosed): _widget_restoreSoftClosed
    // (снимает запись стека и её таймер, _softClosed, раскладка, история, перечитывание при устаревших чипсах, Page widgets)
    // + widget_activate как у Alt+Esc (restoreLastClosedWidget: 'restore', true, true); как и там, у нового верхнего элемента стека
    // таймер снимается — последний закрытый живёт до следующего закрытия. Перебором Tab сюда не попасть: index ходит только по items.
    reopen(j) {
        const st = this.state
        if (!st.open) return
        const it = st.closed[j]
        this.close()
        const W = it?.W
        const store = this.store
        if (!W || !store || W.close) return
        try {
            if (W._softClosed) {
                store._widget_restoreSoftClosed(W)
                const last = store.closedWidgets?.[store.closedWidgets.length - 1]
                if (last?.timerId) { clearTimeout(last.timerId); last.timerId = null }
            }
            store.widget_activate(W, 'altTab:reopen', true, true)
        } catch (e) { if (!store.hide_console) console.warn('altTab: reopen failed', e) }
        this._touch(W.id)
        this.stats.reopens++
        setTimeout(() => this._focus(W), 300)   // виджет показывается на следующем тике, соседи переезжают 250 мс
    },
    // отмена: активность — виджету, который был активен до Alt+Tab (предпросмотр мог её сдвинуть)
    cancel() {
        if (!this.state.open) return
        this.stats.cancels++
        const origW = this._origW
        this.close()
        const store = this.store
        if (origW && store && !origW.close && !origW._softClosed && store.activeWIDGET !== origW) {
            try { store.widget_activate(origW, 'altTab:cancel', true, false) } catch (e) { /* виджет мог исчезнуть */ }
        }
    },
    close() {
        clearTimeout(this._guard); this._guard = null
        this._unlift()
        this._origW = null
        const st = this.state
        st.open = false; st.items = []; st.index = 0; st.currentId = null; st.captions = false
        st.walk = []; st.pos = 0   // IE 2026 09 09 / ODOO-…
        st.closed = []   // IE 2026 09 23 / ODOO-… (заказ Игоря: закрытые виджеты в Alt+Tab)
    },
    // страховка: keyup Alt потерян (окно/iframe) — лист не должен висеть вечно
    _arm() {
        clearTimeout(this._guard)
        this._guard = setTimeout(() => this.cancel(), 20000)
    },
    // клавиатура — в выбранный виджет: его видимый грид; иначе просто снять фокус с прежнего
    _focus(W) {
        try {
            const el = document.getElementById('WIDGET' + W.id)
            if (!el) return
            const ae = document.activeElement
            if (ae && ae !== document.body && !el.contains(ae)) ae.blur()
            const host = [...el.querySelectorAll('.wj-flexgrid')].find(g => g.getClientRects().length > 0)
            const ctrl = host && Control.getControl(host)
            if (ctrl?.focus) ctrl.focus()
        } catch (e) { /* виджет мог исчезнуть */ }
    },
    _eat(e) { e.preventDefault(); e.stopPropagation() },
}

export default altTab
